<template>
  <div class="mb_controller bg">
    <div class="container-fluid px-0 min-height-for-section">
      <div class="w-100 d-flex flex-column align-content-between">
        <div>
          <div class="w-100 position-relative">
            <RadioMainCarousel :active_id="currentid" v-if="currentid" />
            <div class="w-100 breadCrumbsWrapper px-2 px-md-0">
              <BreadCrumbsHeader :mainTitle="'RADIO'" :currentPage="'Radio'" />
            </div>
          </div>
          <div class="row mt-2 mx-3">
            <div class="col-12 px-0 px-md-2">
              <HomepageRadio :active_id="currentid" />
            </div>
          </div>

          <div class="w-100 d-flex justify-content-center my-4 mx-2 pr-4">
            <div class="player-position">
              <div class="w-100">
                <p class="now_playing_title text-center">Now Playing</p>
              </div>
              <div class="playerWrapper d-flex flex-column">
                <div class="playerAbsoluteDiv">
                  <RadioPlayer :id="currentid" :type="'audio'" />
                </div>
              </div>
            </div>
          </div>

          <div class="w-100">
            <div class="col-12">
              <!-- ads -->
              <BillboardBannerBottom v-if="desktop"></BillboardBannerBottom>
              <MrecBannerBottom v-if="mobile"></MrecBannerBottom>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import RadioMainCarousel from "@/components/carousel/radio/radioMainCarousel";
import HomepageRadio from "@/components/carousel/homepageRadio.vue";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
import RadioPlayer from "@/components/players/radioPlayer.vue";
import BillboardBannerBottom from "../components/ads/billboardBannerBottom";
import MrecBannerBottom from "../components/ads/mrecBannerBottom";
import axios from "axios";
export default {
  components: {
    RadioMainCarousel,
    HomepageRadio,
    BreadCrumbsHeader,
    RadioPlayer,
    BillboardBannerBottom,
    MrecBannerBottom,
  },
  data: function() {
    return {
      id: this.$route.params.id,
      currentid: 0,
      radio: [],
      tablet: false,
      mobile: false,
      desktop: false,
    };
  },
  beforeMount() {
    this.initializeContentForStart();
  },
  mounted() {
    this.deviceCheck();
    if (!this.$route.params.id) {
      setTimeout(
        function() {
          this.initializecontentview();
          this.initializepageview();
        }.bind(this),
        700
      );
    }
  },
  methods: {
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    filterOtherFolderData(obj) {
      this.radio.push(obj);
      this.currentid = obj[0].id;
    },
    async getRadioData() {
      try {
        axios
          .get(`https://rtb.glueapi.io/v1/content?idSchema=202&format=json`)
          .then((response) => {
            var radio_order = [4, 7, 6, 3, 5];

            var data = response.data.data;

            data.sort(function(a, b) {
              return radio_order.indexOf(a.id) - radio_order.indexOf(b.id);
            });

            this.filterOtherFolderData(data);
          });
      } catch (e) {
        console.log(e);
      }
    },
    initializecontentview() {
      var self = this;
      var token = localStorage.getItem("token");
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/viewed",
        contentType: "application/json; charset=utf-8",
        headers: {
          "X-AUTH-TOKEN": `${token}`,
        },
        data: JSON.stringify({
          idContent: self.currentid, // Content ID from content api response
          contentTitle: self.$route.path, // Content Longtitle from content api response
          site: "RTBGo",
          dbLogging: 1,
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: "radio",
          site: "RTBGo",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    initializeContentForStart() {
      if (this.id) {
        setTimeout(
          function() {
            this.currentid = this.id;
          }.bind(this),
          400
        );
      } else {
        this.getRadioData();
      }
      //get id from param
      //no param,thus initialize first item in radio list
    },
  },
};
</script>

<style scoped>
.now_playing_title {
  font-size: 22px;
  font-weight: bold;
  line-height: 22px;
  text-align: left;
  color: #fab900;
  text-transform: capitalize;
}
.breadCrumbsWrapper {
  position: absolute;
  top: 88px;
  z-index: 1;
}
.player-position {
  width: 100%;
  max-width: 380px;
}
.playerWrapper {
  height: 52px;
  position: relative;
  width: 100%;
  max-width: 380px;
  overflow: hidden;
}
.playerAbsoluteDiv {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

@media screen and (max-width: 768px) {
  .breadCrumbsWrapper {
    top: 10px;
  }
}
</style>
